<template>
  <BlBackdrop title="Create new databank" label="Create databank" :disabled="isDisabledSubmit"
    :submitLoading="submitLoading" @backdrop-close="$emit('close-modal')" @backdrop-action="onCreate">
    <div class="flex flex-col gap-5 px-8 overflow-y-auto" :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }">
      <div class="grid items-center grid-cols-6 gap-4 py-4">
        <BlInputText class="col-span-6" :input="databankNameInput" @changed="inputHandler" />
        <BlInputText class="col-span-6" :input="descriptionInput" @changed="inputHandler" />

        <!--  -->
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import BlBackdrop from "../../BlBackdrop.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlInputText from "../../BlInputText.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import { mapActions } from "vuex";

export default {
  name: "NewDatabankModal",
  components: {
    BlBackdrop,
    BlTextSubtitle1,
    BlInputText,
    BlSelectBox
  },
  props: {},
  data() {
    return {
      submitLoading: false,
      databankNameInput: {
        label: "Databank name",
        placeholder: "Type name",
        model: "",
        asterisk: true
      },
      descriptionInput: {
        label: "Description",
        placeholder: "Type description",
        textarea: true,
        model: ""
      }
    };
  },
  computed: {
    isDisabledSubmit() {
      if (!this.databankNameInput.model) return true;
      return false;
    }
  },
  watch: {},
  mounted() { },
  methods: {
    ...mapActions(["createDatabank"]),

    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onCreate() {
      const params = {
        databank: {
          name: this.databankNameInput.model,
          description: this.descriptionInput.model
        }
      };
      this.submitLoading = true;
      const { success } = await this.createDatabank(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/databanks/NewDatabankModal.vue